/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * ``POST /inbox/threads/{thread_id}/replies`` response.
 */
export interface ReplySendResponse {
  /** @maxLength 255 */
  workflow_id: string;
  message_id?: string | null;
  scheduled_send_at?: string | null;
}
